import axios from "axios";
import API from "./API";
import Endpoints from "@/V3/Config/Endpoints";

export default {

    getGlobalConfigurations: function () {
        return axios.get(
            API.url(Endpoints.Configurations.Global)
        ).then((res) => {
            return res.data.configurations;
        });
    },

    setGlobalConfiguration: function (configuration) {
        return axios.patch(
            API.url(Endpoints.Configurations.SetGlobal, {configuration_id: configuration.id}) , {
                value: configuration.value
            }
        ).then((res) => {
            return res.data.configurations;
        });
    },

    getCentreConfigurations: function (centreId) {
        return axios.get(
            API.url(Endpoints.Configurations.Centre, {centre_id: centreId})
        ).then((res) => {
            return res.data.configurations;
        });
    },

    setCentreConfiguration: function (configuration, centreId) {
        return axios.patch(
            API.url(Endpoints.Configurations.SetCentre, {
                configuration_id: configuration.id
            }) , {
                value: (configuration.configuration_type.type === 'integer') ?
                    parseInt(configuration.value) : configuration.value
            }
        ).then((res) => {
            return res.data.configurations;
        });
    },
    toggleRemoteAccess: function (centre_id) {
        return axios.patch(
            API.url(Endpoints.Configurations.ToggleRemoteAccess, {
                centre_id: centre_id
            })
        ).then((res) => {
            return res.data.value;
        });
    }
}
